import React from "react";
import classNames from "classnames";
import "./index.scss";

import search_blue_small from "../../../assets/images/icons/search_blue_small.png";
import { courierAssociateFilter, sortByProp, onRouteCourierGroupSort, getCouriersBrokenType } from "../../../services/filter";
import User from "../../../services/user";
import { currentUserIsDepotRole, isRTL } from '../../../services/userModel';
import { CYCLE_STATE, SALARY_CALCULATION_TYPE, SHIFT_TYPE, WAITER_TYPES } from "../../../utils/enums";

import AssociatePopupGroup from "./AssociatePopupGroup";
import { ModalPopup } from "../ModalPopup/ModalPopup";
import AssociatePopupControlCenters from "./associatePopupControlCenters";
import Waiter from "../Waiter/Waiter";
import AssociatePopupExternalProviders from "../AssociatePopupExternalProviders";
import { fetchExternalAssignmentsByIds } from '../../../api/user-requests.js';
import { requestResultIsOk } from '../../../utils/request-util.js';
import { objectKeysToUpperLowerCase } from '../../../utils/objects-util.js';
import { nullOrEmpty } from "../../../utils/helpers.js";
import { getOrdersByIds } from '../../../services/order.js';
import { connect } from "react-redux";
import { getDistance } from "../../../utils/math-util.js";
import IconButton from "../IconButton/IconButton.jsx";
import { associateOrdersToDraft } from "../../../api/order-requests.js";
import AssociatePopupDraft from "../AssociatePopupDraft/AssociatePopupDraft.jsx";
import { useTranslation } from "react-i18next";
import { createAction } from "../../../utils/sagaHelper.js";
import { APPLY_CYCLE_DRAFT, ESTIMATE_CYCLE_DRAFT } from "../../../store/reducers/order/order-actions.js";
import StatusFilter from "./StatusFilter.jsx";
import { filterCourierByStatus } from "../../../utils/tableFiltersHelpers.js";

const EmptySide = ({ type }) => {
  const { t } = useTranslation();

  let icon = '';
  let text = '';
  switch (type) {
    case TABS.couriers:
      icon = 'courierEmptyHelp';
      text = t('dialogs.couriers.COURIER_HELP_PAGE');
      break;

    case TABS.controlCenters:
      icon = 'courierEmptyHelp';
      text = t('dialogs.couriers.CONTROL_CENTER_HELP_PAGE');
      break;

    case TABS.providers:
      icon = 'courierEmptyHelp';
      text = t('dialogs.couriers.EXTERNAL_PROVIDER_HELP_PAGE');
      break;
    default:
      break;
  }

  if (!icon) return null;

  return (
    <div className="emptyHelpScreen">
      <IconButton isIcon iconName={icon} />
      <span className="emptyTitle">{text}</span>
    </div>
  )
}

const TABS = {
  couriers: 'couriers',
  controlCenters: 'controlCenters',
  providers: 'providers'
}

const SORT_MODE = {
  fastest: 1,
  cheapest: 2,
}

const COURIER_SORT = "COURIER_SORT_DASHBOARD";

const COURIER_STATUS_FILTER = "COURIER_STATUS_FILTER";

const courierSortBy = {
  estimation: 'estimation',
  distance: 'distance'
}

const defaultDraftState = {
  draft: null,
  estimation: true,
  modified: false,
  draftOrders: [],
  removedOrdersIds: [],
}

class AssociatePopup extends React.Component {
  constructor(props) {
    super(props);

    const hasCouriers = !!this.filterByControlCenterId(this.couriers).length;

    const selectedTab = !hasCouriers && props.showProviders ? TABS.providers : TABS.couriers;

    let sortMode = null;

    if (selectedTab === TABS.providers) {
      this.changeActiveTab(selectedTab);
      sortMode = SORT_MODE.cheapest;
    }

    const statusFilter = localStorage.getItem(COURIER_STATUS_FILTER) ? JSON.parse(localStorage.getItem(COURIER_STATUS_FILTER)) : [];

    this.state = {
      sortMode,
      searchString: undefined,
      checked: undefined,
      extendableCyclesId: [],
      checkedIds: [],
      selectedTab: selectedTab,
      courierSort: localStorage.getItem(COURIER_SORT) || courierSortBy.estimation,
      enableDraft: User.instance.getCurrentUserConfigurationProp("assignInDraftMode"),
      statusFilter: statusFilter || [],
      ...defaultDraftState,
    };
  }

  get couriers() {
    if (!this.props.couriers) return [];
    return this.props.couriers.filter(courier => {
      let isActive = courier.cycle && (!this.props.courier || courier.userId !== this.props.courier.userId);
      return (
        isActive && courierAssociateFilter(this?.state?.searchString || '', courier)
      );
    });
  }

  get controlCenters() {
    const { controlCenters, selectedControlCenterMulti } = this.props;
    const currentUser = User.instance.getCurrentUserInfo();

    const removeControlCenterId = selectedControlCenterMulti.length === 1 ? selectedControlCenterMulti[0] : null;

    return controlCenters
      ? controlCenters.filter(
        center =>
          center.info != null &&
          center.controlCenterId !== currentUser.controlCenterId &&
          center.controlCenterId !== removeControlCenterId
      )
      : [];
  }

  initState = () => {
    const { selectedOrderIds } = this.props

    fetchExternalAssignmentsByIds(selectedOrderIds).then(response => {
      if (requestResultIsOk(response, true)) {
        const providers = objectKeysToUpperLowerCase(response?.data);
        this.setState({ providers: sortByProp(providers, 'declineReason') });
      }
    })
  }

  getControlCenters = () => {
    const { isGetControlCenters, controlCenterStatus, selectedOrderIds } = this.props;
    if (isGetControlCenters) {
      controlCenterStatus(selectedOrderIds);
    }
  }

  handleChecked = (checked, e, isExternalType, provider, isExternalAssignment) => {

    if (this.state.enableDraft && this.state.selectedTab === TABS.couriers) {
      this.getDraft(checked);
    }
    this.setState({ checked, isExternalType, provider, isExternalAssignment, draft: null, ...defaultDraftState });
  };

  getDraft = (checked) => {
    const { selectedOrderIds } = this.props;

    return associateOrdersToDraft(checked, selectedOrderIds).then(data => {
      if (data.status === 200) {
        const response = objectKeysToUpperLowerCase(data.data);
        this.setState({ draft: response, draftOrders: response.restaurantCycle.orders });
      }
      return data;
    });
  }

  handleCheckedMulti = (ids) => {
    this.setState({ checkedIds: ids, isExternalType: true, checked: !!ids.length ? ids : null });
  }

  handleOnClose = e => {
    this.props.onClose();
  };

  handleOnConfirm = () => {
    const { onConfirm } = this.props;
    const { selectedTab, providers, checked, isExternalType, provider, isExternalAssignment } = this.state;

    if (selectedTab === TABS.providers) {
      return onConfirm(checked
        .map(id => providers.find((draft) => draft.providerCycleId === id))
        .filter(Boolean)
        .map(order => ({
          providerCycleId: order.providerCycleId,
          provider: order.provider,
          providerId: order.providerId,
          orderIds: order.orderIds,
        })),
        true, null, false, true /*assign*/);
    }
    return onConfirm(checked, isExternalType, provider, isExternalAssignment);
  };

  filterByControlCenterId = items => {
    const { controlCenterIds, filterByControlCenterIds } = this.props;
    if (!filterByControlCenterIds) {
      return items;
    }
    const ids = [...new Set(controlCenterIds.filter(Boolean))];
    const idIsNull = ids.length === 0 && controlCenterIds?.includes(null);

    if (ids.length === 1 || idIsNull) {
      return items.filter(c =>
        (idIsNull ? nullOrEmpty(c.cycle.controlCenterId) : c.cycle.controlCenterId === ids[0])
        || (c.cycle.shiftType === SHIFT_TYPE.Backup && c.cycle.controlCenterId === null)
      );
    }
    return [];
  }

  changeActiveTab = tabId => {
    if (tabId === TABS.controlCenters) {
      this.getControlCenters();
    }
    if (tabId === TABS.providers) {
      this.handleOnChangeSort(SORT_MODE.cheapest);
      this.initState();
    }
    this.setState({ selectedTab: tabId, draft: null, checked: null, checkedIds: [], searchString: '' });
  }

  filterControlCenter = (source) => {
    const searchString = this.state.searchString;
    return source.filter(s => s?.name?.toLowerCase()?.includes(searchString?.toLowerCase() || ''));
  }

  filterCourier = (couriers) => {
    if(!this.state.statusFilter.length) {
      return couriers;
    }
    return filterCourierByStatus(couriers, this.state.statusFilter);
  }

  getUsersList = () => {
    const { t } = this.props;
    const { providers, searchString, courierSort } = this.state;

    switch (this.state.selectedTab) {
      case TABS.couriers:
        const items = this.sortCourier(this.filterCourier(this.filterByControlCenterId(this.couriers)));
        return (<AssociatePopupGroup
          maxHeight
          title={t("dialogs.couriers.AVAILABLE_COURIERS_LABEL")}
          emptyTitleText={t(searchString ? "orders.NO_DATA" : "reports.NO_DATA")}
          couriers={items}
          checked={this.state.checked}
          showSalaryType={courierSortBy.estimation === courierSort && this.showSalaryType(items)}
          handleChecked={(value, e) => this.handleChecked(value, e)}
        />);
      case TABS.controlCenters:
        return (<AssociatePopupControlCenters
          hideCourierName
          title={t("dialogs.couriers.CONTROL_CENTERS_LABEL")}
          emptyTitleText={t(searchString ? "orders.NO_DATA" : "reports.NO_DATA")}
          controlCenters={this.filterControlCenter(this.controlCenters)}
          checked={this.state.checked}
          handleChecked={(value, e) => this.handleChecked(value, e)}
        />);
      case TABS.providers:
        return (<AssociatePopupExternalProviders
          checkedIds={this.state.checkedIds}
          ordersInfo={getOrdersByIds(this.props.selectedOrderIds)}
          providers={this.sortProviders(providers)}
          handleChecked={this.handleCheckedMulti}
          emptyTitleText={t("reports.NO_DATA")}
        />);
      default:
        return null;
    }
  }

  handleOnChangeSort = (newSort) => {
    this.setState({ sortMode: newSort });
  }

  getSortButtons = () => {
    const { t } = this.props;
    switch (this.state.selectedTab) {
      case TABS.providers:
        const { sortMode } = this.state
        return (
          <div className={'sortButtons'}>
            <div className={classNames('sortButton', { selected: sortMode === SORT_MODE.cheapest })} onClick={() => this.handleOnChangeSort(SORT_MODE.cheapest)}>{t('dialogs.couriers.CHEAPEST_LABEL')}</div>
            <div className={classNames('sortButton', { selected: sortMode === SORT_MODE.fastest })} onClick={() => this.handleOnChangeSort(SORT_MODE.fastest)}>{t('dialogs.couriers.FASTEST_LABEL')}</div>
          </div>
        );
      default:
        return null;
    }
  }

  sortProviderGroup = (group, sortMode) => {
    return [...(group || [])].sort((a, b) => {
      const aHasInfo = !!a?.priceInfo;
      const bHasInfo = !!b?.priceInfo;

      if (!aHasInfo && bHasInfo) return 1;
      if (aHasInfo && !bHasInfo) return -1;
      if (!aHasInfo && !bHasInfo) return 0;

      if (sortMode === SORT_MODE.fastest) {
        return a?.priceInfo?.estimatedTimeToArrival - b?.priceInfo?.estimatedTimeToArrival;
      }
      if (sortMode === SORT_MODE.cheapest) {
        return a?.priceInfo?.price - b?.priceInfo?.price;
      }
      return 0;
    });
  }

  sortProviders = (source) => {
    const sortMode = this.state.sortMode;
    const map = this.sortProviderGroup(source || [], sortMode).reduce((acc, cv) => {
      const key = `${cv.providerId}-${cv.provider}`;
      if (!acc[key]) acc[key] = [];
      acc[key].push(cv);
      return acc;
    }, {});
    return (Object.values(map) || []).flat().sort((a, b) => (a?.declineReason > 0) - (b?.declineReason > 0));
  }

  showSalaryType = (items) => {
    const calculationModeHourly = items.find(courier => courier.cycle?.salaryCalculationMode === SALARY_CALCULATION_TYPE.Hourly && courier?.cycle && courier.cycle.shiftType !== SHIFT_TYPE.Backup && courier.cycle && courier.cycle.state === CYCLE_STATE.started);
    const calculationModePerOrder = items.find(courier => courier.cycle?.salaryCalculationMode === SALARY_CALCULATION_TYPE.Perorder && courier?.cycle && courier.cycle.shiftType !== SHIFT_TYPE.Backup && courier.cycle && courier.cycle.state === CYCLE_STATE.started);
    return calculationModeHourly && calculationModePerOrder;
  }

  sortCourier = (items) => {
    const courierSort = this.state.courierSort;
    let couriers = items;

    const { availableCouriers, approvedCouriers, onRouteCouriers, backUpCouriers, backUpCouriersAwaiting } = getCouriersBrokenType(couriers);

    const groupedCouriers = [
      ...availableCouriers,
      ...approvedCouriers,
      ...onRouteCouriers,
      ...backUpCouriers,
    ];

    if (courierSort === courierSortBy.estimation) {
      const calculationModeHourly = availableCouriers.find(order => order.cycle?.salaryCalculationMode === SALARY_CALCULATION_TYPE.Hourly);
      const calculationModePerOrder = availableCouriers.find(order => order.cycle?.salaryCalculationMode === SALARY_CALCULATION_TYPE.Perorder);
      const availableCouriersSorted = [...availableCouriers].sort((a, b) => a.cycle?.salaryCalculationMode - b.cycle?.salaryCalculationMode);
      return [
        ...((calculationModeHourly && calculationModePerOrder) ? availableCouriersSorted : onRouteCourierGroupSort(availableCouriers)), 
        ...onRouteCourierGroupSort(approvedCouriers), 
        ...onRouteCourierGroupSort(onRouteCouriers), 
        ...onRouteCourierGroupSort(backUpCouriers),
        ...backUpCouriersAwaiting
      ];
    }

    if (courierSort === courierSortBy.distance) {
      const depots = this.props.depots;
      const selectedOrders = this.props.orders.filter(o => this.props.selectedOrderIds?.includes(o.id));
      const depotsLocation = selectedOrders.map(o => depots.get(o.depotId)?.address?.location).filter(Boolean);

      const result = groupedCouriers.sort((a, b) => {
        const courierLocation = a?.travelData?.location;
        const courierLocation2 = b?.travelData?.location;
        if (!courierLocation && !courierLocation2) return 0;
        if (!courierLocation) return 1;
        if (!courierLocation2) return -1;


        const distances1 = depotsLocation.map(location => {
          return getDistance(courierLocation.latitude, courierLocation.longitude, location.latitude, location.longitude);
        });

        const distances2 = depotsLocation.map(location => {
          return getDistance(courierLocation2.latitude, courierLocation2.longitude, location.latitude, location.longitude);
        });

        return Math.min(...distances1) - Math.min(...distances2);
      });
      return [...result, ...backUpCouriersAwaiting];
    }
  }

  setSort = (sortType) => {
    localStorage.setItem(COURIER_SORT, sortType);
    this.setState({ courierSort: sortType });
  }

  onGetEstimationClick = () => {
    const { getEstimation } = this.props;
    const { draftOrders, checked } = this.state;

    getEstimation({ route: draftOrders, courierId: checked }).then(data => {
      this.setState({ draftOrders: data.orders, estimation: true, modified: true });
    });
  }

  onResetClick = () => {
    this.setState({ draftOrders: this.state.draft.restaurantCycle.orders, estimation: true, modified: false });
  }

  setEstimation = (value) => {
    this.setState({ estimation: value });
  }
  setModified = (value) => {
    this.setState({ modified: value });
  }
  setOrdersDraft = (orders) => {
    this.setState({ draftOrders: orders });
  }
  onRemoveOrder = (ids) => {
    this.setState({ removedOrdersIds: this.state.removedOrdersIds.concat(ids) });
  }
  onApplyDraftCourier = () => {
    const { applyDraftCourier, handleOnOffMultiSelect } = this.props;
    const { draftOrders, checked, removedOrdersIds, draft } = this.state;
    applyDraftCourier({ route: draftOrders, courierId: checked, removedOrders: removedOrdersIds, initialOrderBy: draft.initialOrderBy, sourceGroupId: draft.sourceGroupId }).then(() => {
      this.handleOnClose();
      if(handleOnOffMultiSelect) handleOnOffMultiSelect();
    });
  }

  toggleFilterOpen = () => {
    this.setState({isFilterOpen: !this.state.isFilterOpen});
  }

  setSortStatus = (newValue) => {
    localStorage.setItem(COURIER_STATUS_FILTER, JSON.stringify(newValue));
    this.setState({statusFilter: newValue});
  }

  render() {
    const { t, isOpen, showProviders, showControlCenter, selectedOrderIds } = this.props;
    const { selectedTab, courierSort, draft, enableDraft, estimation, modified, draftOrders, statusFilter, isFilterOpen } = this.state;

    const showOkButton = selectedTab === TABS.couriers ? !enableDraft : true;

    return (
      <ModalPopup
        isOpen={isOpen}
        containerModalClass={classNames('popup-content-modal', { enableDraft, draft: !!draft })}
        onClose={this.handleOnClose}
        content={
          <div className={classNames("popupContainer", { rtl: isRTL(), enableDraft, draft: !!draft })}>
            <div className="popupContainerWrapper">
              <div className="popupContainerDefault">
                <div className={'tabItems'}>
                  <div className={classNames('tabItem', {
                    selected: selectedTab === TABS.couriers
                  })}
                    onClick={() => this.changeActiveTab(TABS.couriers)}
                  >
                    {t("dialogs.couriers.AVAILABLE_COURIERS_LABEL")}
                  </div>
                  {!currentUserIsDepotRole() && showControlCenter && <div className={classNames('tabItem', {
                    selected: selectedTab === TABS.controlCenters
                  })}
                    onClick={() => this.changeActiveTab(TABS.controlCenters)}
                  >
                    {t("dialogs.couriers.CONTROL_CENTERS_LABEL")}
                  </div>}
                  {showProviders && (
                    <div className={classNames('tabItem', {
                      selected: selectedTab === TABS.providers
                    })}
                      onClick={() => this.changeActiveTab(TABS.providers)}
                    >
                      {t("dashboard.couriersbar.EXTERNAL_PROVIDERS_GROUP_LABEL")}
                    </div>
                  )}
                </div>
                {selectedTab !== TABS.providers && (
                  <div className="searchCourier">
                    <div className="searchCourierContainer">
                      <img
                        src={search_blue_small}
                        className="searchIcon"
                        alt="search"
                      />
                      <input
                        type="search"
                        placeholder={t("orders.SEARCH_LABEL")}
                        className="searchInput"
                        value={this.state.searchString}
                        onChange={e =>
                          this.setState({ searchString: e.target.value })
                        }
                      />
                    </div>

                    {selectedTab === TABS.couriers && (
                      <div className="filterButton">
                        <IconButton iconName={'filters'} active={statusFilter?.length} onClick={this.toggleFilterOpen} isIcon />
                        {!!statusFilter?.length && (
                          <div className="filterCount">{statusFilter?.length}</div>
                        )}
                        {isFilterOpen && (
                          <StatusFilter selectedStatus={statusFilter} setSelectedStatus={this.setSortStatus} closeModal={this.toggleFilterOpen}/>                          
                        )}
                      </div>
                    )}

                    {selectedTab === TABS.couriers && (
                      <div className="courierSortButtons">
                        <IconButton iconName={'sortByEstimation'} active={courierSort === courierSortBy.estimation} onClick={() => this.setSort(courierSortBy.estimation)} isIcon />
                        <IconButton iconName={'sortByDistance'} active={courierSort === courierSortBy.distance} onClick={() => this.setSort(courierSortBy.distance)} isIcon />
                      </div>
                    )}
                  </div>
                )}
                {this.getSortButtons()}
                <div className="couriersContainer hideHeader">
                  {this.getUsersList()}
                </div>
              </div>

              {draft && (
                <AssociatePopupDraft
                  estimation={estimation}
                  setEstimation={this.setEstimation}
                  setModified={this.setModified}
                  orders={draftOrders}
                  setOrders={this.setOrdersDraft}
                  courierId={this.state.checked}
                  selectedOrderIds={selectedOrderIds}
                  onRemoveOrder={this.onRemoveOrder}
                />
              )}

              {!draft && enableDraft && <EmptySide type={selectedTab} />}
            </div>

            <div className="courierContainerFooter">
              <button
                className={classNames(
                  "btn",
                  "denied",
                  "courierContainerButton"
                )}
                onClick={e => this.handleOnClose(e)}
              >
                {t("basic.CANCEL_BUTTON")}
              </button>
              {showOkButton && (
                <Waiter
                  useClass="btn confirm courierContainerButton"
                  type={WAITER_TYPES.button}
                  handleOnClick={this.handleOnConfirm}
                  stopPropagation={true}
                  disabled={!this.state.checked}
                  spanText={t("basic.OK_BUTTON")}
                />
              )}

              {selectedTab === TABS.couriers && draft && enableDraft && (
                <>
                  <button
                    className={classNames(
                      "btn",
                      "denied",
                      "courierContainerButton"
                    )}
                    disabled={!!estimation}
                    onClick={this.onGetEstimationClick}
                  >
                    {t("draft.getEstimate")}
                  </button>
                  <button
                    className={classNames(
                      "btn",
                      "denied",
                      "courierContainerButton"
                    )}
                    disabled={!modified}
                    onClick={this.onResetClick}
                  >
                    {t("basic.RESET_BUTTON")}
                  </button>
                  <button
                    className={classNames(
                      "btn",
                      "denied",
                      "courierContainerButton"
                    )}
                    onClick={this.onApplyDraftCourier}
                  >
                    {t("basic.APPLY_BUTTON")}
                  </button>
                </>
              )}
            </div>
          </div>
        }
      />
    );
  }
}

const mstp = (state) => {
  return {
    depots: state.restaurant.data.depotsMap,
    orders: state.order.data.orders,
    showProviders: !!(state.restaurant?.data?.ordersProvider || []).length,
    showControlCenter: !!(state.restaurant?.data?.controlCenters || []).length,
    selectedControlCenterMulti: state.restaurant?.data?.selectedControlCenterMulti || [],
  }
}

const mdtp = (dispatch) => {
  return {
    applyDraftCourier: (data) => dispatch(createAction(APPLY_CYCLE_DRAFT, data)),
    getEstimation: data => dispatch(createAction(ESTIMATE_CYCLE_DRAFT, data)),
  }
}

export default connect(mstp, mdtp)(AssociatePopup);
